<template>
  <drawer
      title="Account"
      z-index="100"
      :right="false"
      :applytext="`${accountItem ? 'Edit': 'Add'}`"
      @updateClose="onClose"
      @updateSave="onSave"
  >
    <div class="accountSettings_body-title">Zelle accounting</div>
    <field
        :class-error="$v.account && $v.account.$error"
        margin="10px 0 10px 0"
        width="100%"
        label="Account"
        :setInputValue="account"
        @updateInput="onInput($event, 'account')"
    ></field>
    <div class="accountSettings_body-title">Account</div>
    <field
        :class-error="$v.number && $v.number.$error"
        margin="10px 0 0 0"
        width="100%"
        label="Account"
        type="number"
        :setInputValue="number"
        @updateInput="onInput($event, 'number')"
    ></field>
    <field
        :class-error="$v.direct_deposit_routing && $v.direct_deposit_routing.$error"
        margin="10px 0 0 0"
        width="100%"
        type="number"
        label="ACH direct deposit Routing"
        :setInputValue="direct_deposit_routing"
        @updateInput="onInput($event, 'direct_deposit_routing')"
    ></field>
    <field
        :class-error="$v.transfer_routing && $v.transfer_routing.$error"
        margin="10px 0 0 0"
        width="100%"
        type="number"
        label="Wire transfer Routing"
        :setInputValue="transfer_routing"
        @updateInput="onInput($event, 'transfer_routing')"
    ></field>
  </drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
	name: "AccountListDrawer",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		accountItem: Object
	},
	data: () => ({
		account: null,
		number: null,
		direct_deposit_routing: null,
		transfer_routing: null,
		id: null,
	}),
	validations: {
		account: { required, email },
		number: { required },
		direct_deposit_routing: { required },
		transfer_routing: { required }
	},
	methods: {
		onInput({ value }, key) {
			this[key] = value;
		},
		onClose() {
			this.$emit('closeDrawer');
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const values = {
					account: this.$data.account,
					number: this.$data.number,
					direct_deposit_routing: this.$data.direct_deposit_routing,
					transfer_routing: this.$data.transfer_routing,
					id: this.$data.id,
				};

				this.$emit('updateAccountList', values);
			}
		}
	},
	mounted() {
		if (this.accountItem) {
			this.account = this.accountItem.account;
			this.number = this.accountItem.number;
			this.direct_deposit_routing = this.accountItem.direct_deposit_routing;
			this.transfer_routing = this.accountItem.transfer_routing;
			this.id = this.accountItem.id;
		}
	}
};
</script>

<style scoped lang="scss">

</style>
